import FetchHelpers from '../../../utils/FetchHelpers';
import formUrl from '../../../utils/routes';

export default {
  load(membershipId) {
    const url = formUrl(`/api/v1/admin/memberships/${membershipId}/bonuses`);

    return FetchHelpers.get(url);
  },

  create(membershipId, params) {
    const url = formUrl(`/api/v1/admin/memberships/${membershipId}/bonuses`);

    return FetchHelpers.post(url, params);
  },

  delete(membershipId, bonusId) {
    const url = formUrl(
      `/api/v1/admin/memberships/${membershipId}/bonuses/${bonusId}`
    );

    return FetchHelpers.delete(url);
  },
};
